//@ts-nocheck
"use client"

import { vxiContentInterpreter } from "../../utils/vxi-content-interpreter";
import Slider, { BlogCard } from "./slider";
import styles from './moonwalker.module.css';
import React, { useEffect, useState } from "react";
import CTABtn from "./cta-btn";
import { useTheme } from "../../utils/theme";
import clsx from "clsx";
import VideoEmbed from "./video-embed";
import Description from "./description";
import Link from "next/link";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { slugBuilder } from "../../utils/slug-builder";

export default function MoonWalker({ awards = null, cxa_hubs = null, vxi_contents = null, embeddeds = null, sliderList = null, leadersList = null, itemListCount = 12, mode, passedFunctions = undefined }) {
    // console.log("from mode", mode, awards?.length);
    // console.log("from mode", mode, awards?.length);
    const isWrapped = Array.isArray(vxi_contents?.data);
    const contentsArray = vxi_contents;

    const [appendedContents, setAppendedContents] = useState([]);
    // Tracks the page number reflected in the URL. Initialized to 1 (SSR-safe);
    // the mount effect below re-reads window.location to honor deep links.
    const [currentPage, setCurrentPage] = useState(1);
    const [nextPage, setNextPage] = useState(2);
    const groupBySeason = (hubs = []) => {
        return hubs.reduce((acc, hub) => {
            const season = hub.season ?? "Other";

            if (!acc[season]) acc[season] = [];
            acc[season].push(hub);

            return acc;
        }, {});
    };
    // 🛠️ Helpers to render each source into JSX
    const renderLeaders = (leadersList = [], passedFunctions) =>
        leadersList.map((lead, i) => {
            const leadAttrs = lead.attributes || lead;
            const imageList = leadAttrs.profile?.attributes?.url;
            return (
                <div key={`${i}-${leadAttrs.name}`} className={styles.slider}>
                    <BlogCard
                        link={leadAttrs.linkedURL}
                        imageList={[imageList]}
                        title={leadAttrs.name}
                        description={leadAttrs.description}
                        passedFunction={() => passedFunctions(i)}
                        bio={leadAttrs.bio}
                    />
                </div>
            );
        });

    const renderContents = (contentsArray = []) =>
        contentsArray.map((content, i) => {
            const interpreted = content.attributes ? vxiContentInterpreter({ ...content.attributes, id: content.id }) : content;
            if (!interpreted.public) return null;

            return (
                <div key={`${i}-${interpreted.title}`} className={styles.slider}>
                    <BlogCard
                        imageList={interpreted.images}
                        vxiContent={interpreted}
                        hubSpotLink={interpreted.hubSpotLink}
                    />
                </div>
            );
        });

    const renderSliderList = (sliderList) =>
        sliderList.map((content, i) => {
            const contentAttrs = content.attributes || {};
            const imageList = contentAttrs.images?.data.map((img) => img.attributes.url) || [];
            return (
                <div key={`${i}-${contentAttrs.sliderTitle}`} className={styles.slider}>
                    <BlogCard
                        link={contentAttrs.link}
                        imageList={imageList}
                        title={contentAttrs.sliderTitle}
                        description={contentAttrs.description}
                    />
                </div>
            );
        });

    const renderEmbeddeds = (embeddeds = []) =>
        embeddeds.map((embed, i) => (
            <div key={i} className={styles.slider}>
                <Slider embed={embed?.attributes} />
            </div>
        ));
    const renderCXAHubs = (cxa_hubs = []) =>
        cxa_hubs.map((hub, i) => {
            const isComingSoon = hub.status === "coming soon";
            const hubHref = isComingSoon ? "" : `/${slugBuilder(null, null, hub.title)}`;
            return (
                <div key={i} className={clsx(styles.slider, styles.cxa, isComingSoon && styles.grayed)}>
                    {hub.embedMedia && <div> <VideoEmbed view="view" url={hub.embedMedia} ctaRedirectURL={isComingSoon ? "" : slugBuilder(null, null, hub.title)} /></div>}
                    <h2 className={styles.title}>{hub.title}</h2>
                    {hub.speakerFullName && <div className={styles.speaker}>{hub.speakerFullName}</div>}
                    {hub.cardDescription && <div className={styles["cxa-desc"]}>{hub.cardDescription}</div>}
                    {!hub.videoLength.includes("Invalid") && <div className={styles["videoLength-container"]}>
                        <div className={styles.videoLength}>{isComingSoon ? `Coming on ${hub.formattedPublishDate}` : hub.videoLength}</div>
                    </div>}
                    <div className={styles.btn}>
                        {hub.title && <CTABtn btnURL={isComingSoon ? "" : slugBuilder(null, null, hub.title)} btnName={isComingSoon ? "Coming Soon" : "Watch"} />}
                    </div>
                </div>
            );
        });
    const AWARD_TINTS = {
        gold: "#F6C453",
        silver: "#C7CED8",
        bronze: "#C67A42",
        neutral: "#636363",
        null: "#636363",
    };
    const renderAwards = (awards = []) =>
        awards.map((aw, i) => {
            const tint =
                AWARD_TINTS[aw.tintRaw?.tint?.toLowerCase()] ??
                AWARD_TINTS.neutral;

            return (
                <div key={i} className={styles.awardsContainer}
                    style={{ "--url": `url(${aw.signedUrl})`, "--tint": tint, "--tint-shine": aw.tintRaw?.tint === "neutral" || aw.tintRaw === null ? "gray" : "white" } as React.CSSProperties}
                >
                    <div className={styles.awardsLogo}>
                        {aw.logoUrl && <img src={aw.logoUrl} alt="" />}
                    </div>
                    <div className={styles.awardsDesc} >
                        {aw.title !== "" &&
                            <div className={styles.awardsTitle}>
                                {aw.title}
                            </div>
                        }
                        <Description description={aw.description} classStyle={`${styles.descFontSize}`} width={90} />
                    </div>
                    <div className={`sectionName ${styles.awardsFooter}`}>
                        {aw.issuer} - {aw.year}
                    </div>
                </div>
            );
        });


    const searchParams = useSearchParams();
    const pathname = usePathname();
    const router = useRouter();
    const baseCount = mode === "showHub" ? 8 : itemListCount;
    const pageStep = 8;
    // Read ?page= only on first mount so deep links/back-forward still work.
    // We deliberately do NOT depend on pageParam in the effect below — otherwise
    // every URL change would reset visibleCount and trigger a re-render flash.
    const pageParam = parseInt(searchParams?.get("page") || "1", 10);
    const initialFromUrl = baseCount + (Number.isFinite(pageParam) && pageParam > 1 ? (pageParam - 1) * pageStep : 0);
    const [visibleCount, setVisibleCount] = useState(initialFromUrl);

    // useSearchParams() is empty during SSR/initial client render in the App Router,
    // so initialFromUrl above resolves to baseCount on first paint. Re-read the
    // real URL on mount and bump visibleCount to honor ?page=N deep links.
    useEffect(() => {
        if (typeof window === "undefined") return;
        const p = parseInt(new URLSearchParams(window.location.search).get("page") || "1", 10);
        // console.log("base count: ", baseCount)
        // console.log("base count: ", baseCount)
        if (Number.isFinite(p) && p > 1) {
            setVisibleCount(baseCount + (p - 1) * pageStep);
            setCurrentPage(p);
            setNextPage(p + 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Reset visibleCount ONLY when itemListCount/mode actually CHANGE.
    // A simple "didMount" ref is unreliable under React 18 Strict Mode
    // (effects double-invoke), so compare against the previous values instead.
    const prevDepsRef = React.useRef({ itemListCount, mode });
    useEffect(() => {
        const prev = prevDepsRef.current;
        if (prev.itemListCount !== itemListCount || prev.mode !== mode) {
            prevDepsRef.current = { itemListCount, mode };
            setVisibleCount(baseCount);
        }
    }, [itemListCount, mode, baseCount]);

    // Silently sync ?page=N into the URL bar without invoking Next's router
    // (which would re-run the server component and feel like a refresh).
    // Pass an explicit page number — don't derive it from item count, since
    // API batch sizes vary and the math becomes unreliable.
    const syncPageInUrl = (pageNum) => {
        if (typeof window === "undefined") return;
        const safe = Math.max(1, pageNum | 0);
        const params = new URLSearchParams(window.location.search);
        if (safe <= 1) params.delete("page");
        else params.set("page", String(safe));
        const qs = params.toString();
        const newUrl = `${window.location.pathname}${qs ? `?${qs}` : ""}${window.location.hash}`;
        window.history.replaceState(window.history.state, "", newUrl);
    };
    // 📝 Combine all
    const mergedContentsArray = [
        ...(Array.isArray(contentsArray) ? contentsArray : (contentsArray?.data || [])),
        ...appendedContents,
    ];

    const allItems = [
        ...renderLeaders(leadersList || [], passedFunctions),
        ...renderContents(mergedContentsArray, isWrapped),
        ...renderSliderList(sliderList || []),
        ...renderEmbeddeds(embeddeds || []),
        ...renderCXAHubs(cxa_hubs || [], visibleCount),
        ...renderAwards(awards || [])
    ].filter(Boolean);

    const [showAll, setShowAll] = useState(false);

    const visibleItems = mode !== "slider" ? allItems.slice(0, visibleCount) : allItems;

    const buildNextPageHref = (nextCount) => {
        const path = pathname || "#";
        const nextPage = Math.max(1, Math.ceil((nextCount - baseCount) / pageStep) + 1);
        const params = new URLSearchParams(searchParams?.toString() || "");
        if (nextPage <= 1) {
            params.delete("page");
        } else {
            params.set("page", String(nextPage));
        }
        const qs = params.toString();
        return qs ? `${path}?${qs}` : path;
    };

    const handleShowMore = () => {
        setVisibleCount((prevCount) => prevCount + 8);
        setCurrentPage((p) => {
            const next = p + 1;
            syncPageInUrl(next);
            return next;
        });
    };
    const handleShowMoreShow = async () => {
        const params = new URLSearchParams(searchParams?.toString() || "");
        // Don't leak ?page= into the URL we send to the API \u2014 the page number
        // belongs in the body only. Otherwise the backend may read it from the
        // URL and serve the wrong batch.
        params.delete("page");
        const slug = (pathname || "").replace(/^\/+/, "");
        const slugWithParams = params.toString()
            ? `${slug}/?${params.toString()}`
            : `${slug}/`;

        const response = await fetch("/api/search-vxi-contents", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                url: slugWithParams,
                page: nextPage,
            }),
        });
        const result = await response.json();
        // console.log("fetchVxiByUrl result:", result, " from: ", vxi_contents);

        if (Array.isArray(result?.data) && result.data.length > 0) {
            setAppendedContents((prev) => {
                const merged = [...prev, ...result.data];
                const initialCount = Array.isArray(contentsArray)
                    ? contentsArray.length
                    : (contentsArray?.data?.length || 0);
                console.log(
                    `[MoonWalker] Show More: fetched ${result.data.length} new items \u2192 total now ${initialCount + merged.length} (initial ${initialCount} + appended ${merged.length})`
                );
                return merged;
            });
            setVisibleCount((prev) => prev + result.data.length);
            setCurrentPage((p) => {
                const next = p + 1;
                syncPageInUrl(next);
                return next;
            });
        }

        const newNext = result?.pagination?.nextPage;
        if (newNext) {
            setNextPage(newNext);
        } else {
            setNextPage((prev) => prev + 1);
        }
    };
    const { theme } = useTheme();
    const lightMode = theme === "light";
    const totalHubCount = cxa_hubs?.length ?? 0;
    const canShowMoreHubs = visibleCount < totalHubCount;
    const canShowLessHubs = visibleCount > itemListCount;
    // console.log(visibleCount, " ", totalHubCount, " ", canShowMoreHubs, " ", canShowLessHubs)
    return (
        <div className={clsx(styles.container, { [styles["light-mode"]]: lightMode })}>

            {mode !== "showHub" && mode !== "slider" && visibleItems.length > 12 && (
                <button
                    className={styles["show-more-btn"]}
                    onClick={() => {
                        setVisibleCount(itemListCount);
                        setCurrentPage(1);
                        syncPageInUrl(1);
                    }}
                >
                    Show Less
                </button>
            )}
            <div className={`${styles["moonwalk-wrapper"]} ${(mode === "show" && visibleItems.length >= 4) || mode === "showHub" ? styles["four-or-more"] : ""}`}
                style={{ "--item-list-count": 4, }}>
                {mode === "showHub" && canShowLessHubs && (
                    <button
                        className={styles["show-more-btn-hub"]}
                        onClick={() => {
                            setVisibleCount(8);
                            setCurrentPage(1);
                            syncPageInUrl(1);
                        }}
                    >
                        Show Less
                    </button>
                )}
                {visibleItems}
            </div>
            {mode === "showHub" && canShowMoreHubs && (
                <div className={styles["show-more-btn-bottom"]}>
                    <button onClick={handleShowMore}>
                        Show More
                    </button>
                </div>
            )}

            {mode !== "showHub" && mode !== "slider" && visibleItems.length >= 12 && (
                <div className={styles["show-more-btn-bottom"]}>
                    <button onClick={handleShowMoreShow}>
                        Show More
                    </button>
                </div>
            )}
        </div>
    );
};